import common from "../common";
import Button from "./Button";

export default class CheckboxButton extends Button {

    constructor(label, id, value, checked, required, css)
    {
        if(css == null) css = {};

        super(css); //runs init

        this.required = required;

        this.initCheckbox(label, id, value, checked);
    }

    initCheckbox(label, id, value, checked)
    {
        this.type = this.TYPE_CHECKBOX;

        this.htmlElement.css({'cursor':'default'})

        this.formElement = $("<input class='p3-checkbox' type='checkbox' id='" + id + "' name='" + id + "' value='" + value + "' " + (checked ? 'checked' : '') + ">");
        this.htmlElement.append(this.formElement);

        this.formElement.on('change', function(){
            this.signals.changed.dispatch();
        }.bind(this));

        this.addListeners();

        //this.formElementLabel = $("<label class='p3-checkboxLabel' for='" + id + "'>" + label + "</label>");
        this.formElementLabel = $("<span class='p3-checkboxLabel'>" + label + "</span>");
        if(this.required)
            this.formElementLabel.addClass('p3-boldText')
        this.htmlElement.append(this.formElementLabel);
    }

    isChecked()
    {
        return this.formElement.is(':checked');
    }
}